import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";

/**
 * sets category of the selected attacker
 * @param {string} id - uuid of the attacker
 * @param {string} category - string value of attacker category
 *
 */
export const setAttackerCategory = ({ id, category }) => {
  return Brm.attackerApi.setAttackerCategory(id, { body: category });
};

/**
 * Custom hook to change the category of a existing Attacker
 * @param {object} config hook configuration
 * @returns react-query ReactQuery.useMutation
 */
export const useSetAttackerCategory = ({ config = {} }) => {
  return ReactQuery.useMutation({
    ...config,
    mutationFn: setAttackerCategory,
  });
};
